var _templateObject;
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled, { withTheme, css } from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { sizes } from './sizes';
import { SmallStars } from './Variants';
var defaultSize = 'xsmall';
var StyledStars = styled.div.withConfig({
  displayName: "Stars__StyledStars",
  componentId: "sc-afn5ru-0"
})(["display:inline-flex;", " svg{vertical-align:text-top;", ";", ";}", ""], function (_ref) {
  var inverse = _ref.inverse;
  return inverse ? "direction: rtl;" : '';
}, function (_ref2) {
  var size = _ref2.size;
  return sizes[size] && "width: ".concat(sizes[size], "px;");
}, function (_ref3) {
  var size = _ref3.size;
  return sizes[size] && "height: ".concat(sizes[size], "px;");
}, maxMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n  "])), function (props) {
  return props.fluid && css(["svg{width:5vw;height:5vw;}"]);
}));
var DisabledType = function DisabledType(_ref4) {
  var disabledMode = _ref4.disabledMode,
    theme = _ref4.theme,
    useEmptyColor = _ref4.useEmptyColor;
  var color = useEmptyColor ? theme.ratingStarEmptyColor : theme.ratingStarColor ? theme.ratingStarColor : '#FFD552';
  switch (disabledMode) {
    case 'stroke':
      return React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.99998 0.666656C8.25372 0.666656 8.48547 0.810705 8.59778 1.03824L10.5028 4.89763L14.7631 5.52033C15.0141 5.55703 15.2226 5.73303 15.3008 5.97437C15.3791 6.21571 15.3135 6.48054 15.1318 6.65756L12.0497 9.65957L12.7771 13.9006C12.8199 14.1508 12.7171 14.4035 12.5118 14.5527C12.3065 14.7018 12.0343 14.7215 11.8097 14.6034L7.99998 12.5999L4.19028 14.6034C3.96567 14.7215 3.69347 14.7018 3.48816 14.5527C3.28284 14.4035 3.18001 14.1508 3.22291 13.9006L3.9503 9.65957L0.868157 6.65756C0.686411 6.48054 0.620896 6.21571 0.699148 5.97437C0.7774 5.73303 0.985853 5.55703 1.23689 5.52033L5.49714 4.89763L7.40217 1.03824C7.51449 0.810705 7.74623 0.666656 7.99998 0.666656ZM7.99998 2.83949L6.53778 5.80174C6.44076 5.9983 6.2533 6.13461 6.0364 6.16631L2.76559 6.64439L5.1318 8.94909C5.28905 9.10225 5.36082 9.323 5.32372 9.53935L4.76543 12.7944L7.68968 11.2566C7.88393 11.1545 8.11602 11.1545 8.31028 11.2566L11.2345 12.7944L10.6762 9.53935C10.6391 9.323 10.7109 9.10225 10.8682 8.94909L13.2344 6.64439L9.96356 6.16631C9.74666 6.13461 9.5592 5.9983 9.46217 5.80174L7.99998 2.83949Z",
        fill: color
      });
    case 'fill':
      return React.createElement("path", {
        d: "M7.99998 0.666656C8.25372 0.666656 8.48547 0.810705 8.59778 1.03824L10.5028 4.89763L14.7631 5.52033C15.0141 5.55703 15.2226 5.73303 15.3008 5.97437C15.3791 6.21571 15.3135 6.48054 15.1318 6.65756L12.0497 9.65957L12.7771 13.9006C12.8199 14.1508 12.7171 14.4035 12.5118 14.5527C12.3065 14.7018 12.0343 14.7215 11.8097 14.6034L7.99998 12.5999L4.19028 14.6034C3.96567 14.7215 3.69347 14.7018 3.48816 14.5527C3.28284 14.4035 3.18001 14.1508 3.22291 13.9006L3.9503 9.65957L0.868157 6.65756C0.686411 6.48054 0.620896 6.21571 0.699148 5.97437C0.7774 5.73303 0.985853 5.55703 1.23689 5.52033L5.49714 4.89763L7.40217 1.03824C7.51449 0.810705 7.74623 0.666656 7.99998 0.666656Z",
        fill: color
      });
    default:
      return React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.99998 0.666656C8.25372 0.666656 8.48547 0.810705 8.59778 1.03824L10.5028 4.89763L14.7631 5.52033C15.0141 5.55703 15.2226 5.73303 15.3008 5.97437C15.3791 6.21571 15.3135 6.48054 15.1318 6.65756L12.0497 9.65957L12.7771 13.9006C12.8199 14.1508 12.7171 14.4035 12.5118 14.5527C12.3065 14.7018 12.0343 14.7215 11.8097 14.6034L7.99998 12.5999L4.19028 14.6034C3.96567 14.7215 3.69347 14.7018 3.48816 14.5527C3.28284 14.4035 3.18001 14.1508 3.22291 13.9006L3.9503 9.65957L0.868157 6.65756C0.686411 6.48054 0.620896 6.21571 0.699148 5.97437C0.7774 5.73303 0.985853 5.55703 1.23689 5.52033L5.49714 4.89763L7.40217 1.03824C7.51449 0.810705 7.74623 0.666656 7.99998 0.666656ZM7.99998 2.83949L6.53778 5.80174C6.44076 5.9983 6.2533 6.13461 6.0364 6.16631L2.76559 6.64439L5.1318 8.94909C5.28905 9.10225 5.36082 9.323 5.32372 9.53935L4.76543 12.7944L7.68968 11.2566C7.88393 11.1545 8.11602 11.1545 8.31028 11.2566L11.2345 12.7944L10.6762 9.53935C10.6391 9.323 10.7109 9.10225 10.8682 8.94909L13.2344 6.64439L9.96356 6.16631C9.74666 6.13461 9.5592 5.9983 9.46217 5.80174L7.99998 2.83949Z",
        fill: color
      });
  }
};
var Stars = function Stars(_ref5) {
  var value = _ref5.value,
    size = _ref5.size,
    variant = _ref5.variant,
    reviews = _ref5.reviews,
    disabledMode = _ref5.disabledMode,
    useEmptyColor = _ref5.useEmptyColor,
    theme = _ref5.theme,
    fluid = _ref5.fluid,
    inverse = _ref5.inverse;
  if (typeof variant !== 'undefined' && variant === 'small') {
    return React.createElement(SmallStars, {
      value: value,
      size: size,
      reviews: reviews
    });
  }
  return React.createElement(StyledStars, {
    fluid: fluid,
    size: size || defaultSize,
    inverse: inverse
  }, [1, 2, 3, 4, 5].map(function (star, index) {
    return value >= star ? React.createElement("svg", {
      key: index,
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, React.createElement("path", {
      d: "M7.99998 0.666656C8.25372 0.666656 8.48547 0.810705 8.59778 1.03824L10.5028 4.89763L14.7631 5.52033C15.0141 5.55703 15.2226 5.73303 15.3008 5.97437C15.3791 6.21571 15.3135 6.48054 15.1318 6.65756L12.0497 9.65957L12.7771 13.9006C12.8199 14.1508 12.7171 14.4035 12.5118 14.5527C12.3065 14.7018 12.0343 14.7215 11.8097 14.6034L7.99998 12.5999L4.19028 14.6034C3.96567 14.7215 3.69347 14.7018 3.48816 14.5527C3.28284 14.4035 3.18001 14.1508 3.22291 13.9006L3.9503 9.65957L0.868157 6.65756C0.686411 6.48054 0.620896 6.21571 0.699148 5.97437C0.7774 5.73303 0.985853 5.55703 1.23689 5.52033L5.49714 4.89763L7.40217 1.03824C7.51449 0.810705 7.74623 0.666656 7.99998 0.666656Z",
      fill: theme.ratingStarColor ? theme.ratingStarColor : '#FFD552'
    })) : React.createElement("svg", {
      key: index,
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, React.createElement(DisabledType, {
      disabledMode: disabledMode,
      theme: theme,
      useEmptyColor: useEmptyColor
    }));
  }));
};
export default withTheme(Stars);